export default "__VITE_ASSET__q6ZVxm95__"